import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationStart } from '@angular/router';
import { AuthService } from '../services/authService';
import { User } from '../models/user';

@Component({
  selector: 'app-contact',
  standalone: false,
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  renderer: Renderer2;
  user = new User('', false);
  contactForm = new FormGroup({
    firstOptionsSet: new FormControl("", [
      Validators.required,
      Validators.min(1),
      Validators.max(6),
    ]),
    accountInformationOptionsSet: new FormControl("", [
      Validators.required,
      Validators.min(1),
      Validators.max(2),
    ]),
    myAccountInformationOptionsSet: new FormControl("", [
      Validators.required,
      Validators.min(1),
      Validators.max(3),
    ]),
    privacyQuestionsOptionsSet: new FormControl("", [
      Validators.required,
      Validators.min(1),
      Validators.max(7),
    ]),
  });

  constructor(private authService: AuthService, private http: HttpClient, public el: ElementRef, renderer: Renderer2, public router: Router) {
    this.renderer = renderer;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.contactForm.reset({
          firstOptionsSet: '',
          accountInformationOptionsSet: '',
          myAccountInformationOptionsSet: ''
        });
      }
    });
  }

  async ngOnInit(): Promise<void> {
    this.contactForm.reset({
      firstOptionsSet: '',
      accountInformationOptionsSet: '',
      myAccountInformationOptionsSet: ''
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.handlePopState);
  }

  private handlePopState(event: PopStateEvent): void {
    console.log('Navigated via back button:', event);
  }

  public handleFirstOptionsSetChange(): void {
    const accountInformationOptions = this.el.nativeElement.querySelector('#divAccountInformationOptions');
    const privacyQuestionOptions = this.el.nativeElement.querySelector('#divPrivacyQuestionOptions');

    switch (this.contactForm.controls.firstOptionsSet.value) {
      case '1':
        if (accountInformationOptions && accountInformationOptions.classList.contains('d-none')) {
          this.renderer.removeClass(this.el.nativeElement.querySelector('#divAccountInformationOptions'), 'd-none');
        }
        if (privacyQuestionOptions && !privacyQuestionOptions.classList.contains('d-none')) {
          this.renderer.addClass(this.el.nativeElement.querySelector('#divPrivacyQuestionOptions'), 'd-none');
        }
        break;
      case '2':
        if (accountInformationOptions && !accountInformationOptions.classList.contains('d-none')) {
          this.renderer.addClass(this.el.nativeElement.querySelector('#divAccountInformationOptions'), 'd-none');
        }
        if (privacyQuestionOptions && privacyQuestionOptions.classList.contains('d-none')) {
          this.renderer.removeClass(this.el.nativeElement.querySelector('#divPrivacyQuestionOptions'), 'd-none');
        }
        break;
      default:
        if (accountInformationOptions && !accountInformationOptions.classList.contains('d-none')) {
          this.renderer.addClass(this.el.nativeElement.querySelector('#divAccountInformationOptions'), 'd-none');
        }
        if (privacyQuestionOptions && !privacyQuestionOptions.classList.contains('d-none')) {
          this.renderer.addClass(this.el.nativeElement.querySelector('#divPrivacyQuestionOptions'), 'd-none');
        }
        this.contactForm.controls.firstOptionsSet.setValue('');
    }
  }

  public handleAcctInfoOptionsSetChange(): void {
    const someOneElsesInfoElement = this.el.nativeElement.querySelector('#divSomeOneElsesInformation');
    const myAccountInfoOptionsElement = this.el.nativeElement.querySelector('#divMyAccountInformationOptions');

    switch (this.contactForm.controls.accountInformationOptionsSet.value) {
      case '1':
        // remove the d-none css class from this.contactForm.controls.myAccountInformationOptionsSet
        this.renderer.removeClass(this.el.nativeElement.querySelector('#divMyAccountInformationOptions'), 'd-none');
        if (someOneElsesInfoElement && !someOneElsesInfoElement.classList.contains('d-none')) {
          this.renderer.addClass(someOneElsesInfoElement, 'd-none');
        }
        break;
      case '2':
        this.renderer.removeClass(this.el.nativeElement.querySelector('#divSomeOneElsesInformation'), 'd-none');
        if (myAccountInfoOptionsElement && !myAccountInfoOptionsElement.classList.contains('d-none')) {
          this.hideMyAccountInformationSelections();
        }
        break;
      default:
        if (someOneElsesInfoElement && !someOneElsesInfoElement.classList.contains('d-none')) {
          this.renderer.addClass(someOneElsesInfoElement, 'd-none');
        }
        if (myAccountInfoOptionsElement && !myAccountInfoOptionsElement.classList.contains('d-none')) {
          this.renderer.addClass(myAccountInfoOptionsElement, 'd-none');
        }
        this.hideMyAccountInformationSelections();
    }
  }

  private hideMyAccountInformationSelections(): void {
    this.renderer.addClass(this.el.nativeElement.querySelector('#divMyAccountInformationOptions'), 'd-none');
    this.hideMyAccountInformationOptionOneResponse();
    this.hideMyAccountInformationOptionTwoResponse();
    this.hideMyAccountInformationOptionThreeResponse();
  }

  public handleMyAcctInfoOptionsSetChange(): void {

    switch (this.contactForm.controls.myAccountInformationOptionsSet.value) {
      case '1':
        this.renderer.removeClass(this.el.nativeElement.querySelector('#myAccountOptionOneResponse'), 'd-none');
        this.hideMyAccountInformationOptionTwoResponse();
        this.hideMyAccountInformationOptionThreeResponse();
        break;
      case '2':
        this.renderer.removeClass(this.el.nativeElement.querySelector('#myAccountOptionTwoResponse'), 'd-none');
        this.hideMyAccountInformationOptionOneResponse();
        this.hideMyAccountInformationOptionThreeResponse();
        break;
      case '3':
        this.renderer.removeClass(this.el.nativeElement.querySelector('#myAccountOptionThreeResponse'), 'd-none');
        this.hideMyAccountInformationOptionOneResponse();
        this.hideMyAccountInformationOptionTwoResponse();
        break;
      default:
        this.hideMyAccountInformationOptionOneResponse();
        this.hideMyAccountInformationOptionTwoResponse();
        this.hideMyAccountInformationOptionThreeResponse();
    }
  }

  private hideMyAccountInformationOptionOneResponse(): void {
    this.renderer.addClass(this.el.nativeElement.querySelector('#myAccountOptionOneResponse'), 'd-none');
  }

  private hideMyAccountInformationOptionTwoResponse(): void {
    this.renderer.addClass(this.el.nativeElement.querySelector('#myAccountOptionTwoResponse'), 'd-none');
  }

  private hideMyAccountInformationOptionThreeResponse(): void {
    this.renderer.addClass(this.el.nativeElement.querySelector('#myAccountOptionThreeResponse'), 'd-none');
  }
}
